<h1 matDialogTitle>{{data.title}}</h1>

<mat-dialog-content>
  <div style="display: flex;flex-direction: column;">
    <div class="text-container">
        {{data.text}}
    </div>

    <mat-form-field fxFlex="100" width="100%">
      <mat-label>Reason</mat-label>
      <textarea matInput rows="2" style="text-align: left;" type="text" minlength="1" maxlength="200" [(ngModel)]="reasonText" autocomplete="new-password"></textarea>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button *ngIf="data.showCancelButton" (click)="cancelClicked()">Close</button>
    <button mat-button *ngIf="data.showConfirmButton" (click)="confirmClicked()"
        [disabled]="!reasonText">{{data.confirmButtonText}}</button>
</mat-dialog-actions>
